import React, { useEffect, useContext, useState } from "react";
import { RentContext } from "../../../contexts/RentContext";
import { UserContext } from "../../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import { domain } from "../../../config";
import { Link } from "react-router-dom";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import RentAction from "../__action/RentAction";
import Popup from "../../Popup/Popup";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

const RentTable = ({ setIsOpen, isOpen, startDate, endDate }) => {
  const { rent, setRent } = useContext(RentContext);
  const [isPopup, setPopup] = useState(false);
  const [infoMsg, setInfoMsg] = useState("");
  const [clear, setClear] = useState(false);
  const [clearBtn, setClearBtn] = useState(false);
  const [filterByStart, setFilterByStart] = useState();
  const [filterByEnd, setFilterByEnd] = useState();
  const { user, setUser } = useContext(UserContext);
  const [isPembayaran, setIsPembayaran] = useState({
    status: false,
    value: "",
    id: "",
  });
  const [filter, setFilter] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const token = localStorage.getItem("token");
  const [selectedCity, setSelectedCity] = useState(null);
  const cities = [{ name: "Cash" }, { name: "BCA" }];

  const nav = useNavigate();

  const drillData = async () => {
    setFilterByStart(
      startDate.toLocaleDateString("en-US", { format: "%Y-%m-%d" })
    );
    setFilterByEnd(endDate.toLocaleDateString("en-US", { format: "%Y-%m-%d" }));

    const fetchData = async () => {
      setPopup(true);
      setInfoMsg("Loading");
      const data = await fetch(`${domain}/customer/dashboardDrill`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          startDate: startDate,
          endDate: endDate,
        }),
      });

      const response = await data.json();
      if (data.ok) {
        setPopup(false);
        setRent(response.doc);
      } else if (!data.ok) {
        if (response.message == "jwt expired") {
          console.log("error");
          setUser(false);
          nav("/login");
        }
      }
    };
    fetchData();
  };
  const fetchData = async () => {
    setPopup(true);
    setInfoMsg("Loading");
    const data = await fetch(`${domain}/rent`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const response = await data.json();
    if (data.ok) {
      setPopup(false);
      setRent(response.rentDoc);
    } else if (!data.ok) {
      if (
        response.message == "jwt expired" ||
        response.message == "jwt malformed"
      ) {
        console.log("error");
        setUser(false);
        nav("/login");
      }
    }
  };
  useEffect(() => {
    if (startDate && endDate) {
      drillData();
      setClearBtn(true);
    } else {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (clear) {
      fetchData();
    }
  }, [clear]);

  const handlePembayaran = (value, id) => {
    setIsPembayaran({ status: true, id: id, value: value });
    setPopup(true);
  };

  const exportToExcel = () => {
    const fetchData = async () => {
      setPopup(true);
      setInfoMsg("Loading");

      try {
        const data = await fetch(`${domain}/rent-excel`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          method: "POST",
        });

        if (!data.ok) {
          const errorResponse = await data.json();
          if (
            errorResponse.message === "jwt expired" ||
            errorResponse.message === "jwt malformed"
          ) {
            console.log("Token expired");
            setUser(false);
            nav("/login");
            return;
          } else {
            console.error("Error in response:", errorResponse.message);
            setPopup(false);
            // Handle other error scenarios if needed
            return;
          }
        }

        const blob = await data.blob();
        console.log(blob);

        if (blob) {
          setPopup(false);
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "rents.xlsx";
          link.click();
          URL.revokeObjectURL(url);
        } else {
          console.error("Blob not found");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle other errors if needed
      }
    };

    fetchData();
  };

  return (
    <>
      <Popup
        isOpen={isPopup}
        setIsOpen={setPopup}
        infoMsg={infoMsg}
        setInfoMsg={setInfoMsg}
        isPembayaran={isPembayaran.status}
        id={isPembayaran.id}
        value={isPembayaran.value.name}
        setIsPembayaran={setIsPembayaran}
      />
      <div style={{ display: "flex", marginTop: "10px" }}>
        <Button
          onClick={() => setIsOpen(!isOpen)}
          severity="secondary"
          style={{ marginBottom: "10px", marginRight: "10px" }}
        >
          New Rent
        </Button>

        <InputText
          placeholder="Keyword Search"
          style={{
            display: "block",
            marginBottom: "10px",
          }}
          onInput={(e) => {
            setFilter({
              ...filter,
              global: {
                value: e.target.value,
                matchMode: FilterMatchMode.CONTAINS,
              },
            });
          }}
        />
        <Button
          style={{ marginBottom: "10px", marginLeft: "10px", marginRight: 10 }}
          severity="success"
          onClick={() => exportToExcel()}
          size="small"
        >
          Export To Excel
        </Button>
        {!clear && clearBtn && (
          <p onClick={() => setClear(true)} style={{ cursor: "pointer" }}>
            <u>Clear Rent </u>
            Filter by {filterByStart} to {filterByEnd}
          </p>
        )}
      </div>

      <DataTable
        value={rent}
        stripedRows
        showGridlines
        filters={filter}
        dataKey="_id"
        tableStyle={{ minWidth: "70rem" }}
        paginator
        rows={10}
        removableSort
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="rentNo"
          header="No Rent"
          sortable
          body={(rent) => {
            return (
              <Link
                to={`/rent/${rent._id}`}
                className="customer__name"
                style={{ color: "blue" }}
              >
                {rent.rentNo}
              </Link>
            );
          }}
        ></Column>
        <Column
          field="customer.displayName"
          header="Customer"
          body={(name) => {
            return (
              <div style={{ color: "blue", fontWeight: "bold" }}>
                {name.customer.displayName}
              </div>
            );
          }}
          sortable
        ></Column>
        <Column
          field={(e) => {
            return e.product.map((p, index) => {
              return p.productID.displayName;
            });
          }}
          body={(e) => {
            return e.product.map((p, index) => {
              return p.productID.displayName + ", ";
            });
          }}
          header="Product"
          style={{ minWidth: "20rem" }}
        ></Column>
        <Column field="customer.address" sortable header="Address"></Column>
        <Column
          field="tglTr"
          body={(e) => {
            return new Date(e.tglTr).toLocaleString();
          }}
          header="Tanggal Transaksi"
          sortable
        ></Column>
        <Column
          field="paymentStatus"
          body={(e) => {
            return e.paymentStatus == "Not Paid" ? (
              <Dropdown
                value={selectedCity}
                onChange={(value) => {
                  console.log(value.value);
                  handlePembayaran(value.value, e._id);
                }}
                options={cities}
                optionLabel="name"
                placeholder="Terima Pembayaran"
                className="w-full md:w-14rem"
              />
            ) : (
              e.paymentStatus
            );
          }}
          header="Payment"
          sortable
        ></Column>
        <Column
          field="total"
          header="Total"
          sortable
          body={(e) => {
            return new Intl.NumberFormat("id-ID", {
              style: "currency",
              currency: "IDR",
            }).format(e.grandTotal);
          }}
        ></Column>
        <Column
          header="Action"
          body={(d) => {
            return (
              <RentAction
                id={d._id}
                key={d._id}
                isPopup={isPopup}
                setPopup={setPopup}
                setInfoMsg={setInfoMsg}
                phone={d.customer && d.customer.phone}
                customer={d.customer && d.customer.displayName}
                total={new Intl.NumberFormat("id-ID", {
                  style: "currency",
                  currency: "IDR",
                }).format(d.grandTotal)}
                rentNo={d.rentNo}
              />
            );
          }}
        ></Column>
      </DataTable>
    </>
  );
};

export default RentTable;
